/**
 * Google Analytics 4 — inicialização dinâmica.
 *
 * O Measurement ID é lido da API do servidor, permitindo que o admin
 * configure/desative o rastreamento sem rebuild do frontend.
 */
export async function initGoogleAnalytics() {
  try {
    const res = await fetch('/api/system-settings/google-analytics');
    if (!res.ok) return;

    const data = await res.json();
    const measurementId = data?.measurementId;

    if (!measurementId || typeof measurementId !== 'string') return;
    if (!/^G-[A-Z0-9]+$/u.test(measurementId)) return;

    // Forma canonica recomendada pelo Google. O gtag.js inspeciona
    // dataLayer esperando objetos `Arguments`, por isso usamos uma
    // funcao tradicional que faz `dataLayer.push(arguments)` em vez
    // de uma arrow com rest params.
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };

    window.gtag('js', new Date());
    window.gtag('config', measurementId);

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;
    document.head.appendChild(script);
  } catch (_error) {
    // Falha silenciosa: analytics nunca deve quebrar o app
  }
}

/**
 * Envia uma métrica Web Vital para o GA4 (se já inicializado).
 * Chamada por reportWebVitals em index.js.
 */
export function sendWebVitalToGa4({ name, delta, id }) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', name, {
    event_category: 'Web Vitals',
    event_label: id,
    value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    non_interaction: true,
  });
}
